import { type UiLibI18n } from '@myre/domain-i18n-wordings';
import { ModalService } from '@myre/ui-primitive-modal';

import { inject, Injectable } from '@angular/core';

import { WORDINGS } from '../../myre-wordings-loader';

import { CitationDetailComponent } from '../components/citation-detail/citation-detail.component';
import { type Citation } from '../interfaces/chat.interfaces';

/**
 * The chat window pins itself above the app's notification layer
 * (chat-window.component.scss: z-index 10000001); the evidence modal must
 * clear it too or it opens underneath the chat.
 */
const ABOVE_CHAT_Z_INDEX = 10000002;

/**
 * Opens the evidence modal for a citation — shared by the sources block and
 * the inline [n] markers in the message text.
 */
@Injectable({ providedIn: 'root' })
export class CitationModalService {
  private readonly _modalService = inject(ModalService);
  private readonly _wordings = inject<UiLibI18n>(WORDINGS);

  public open(citation: Citation): void {
    this._modalService.openFactory(uid => ({
      key: 'citation.detail',
      size: 'large',
      zIndex: ABOVE_CHAT_Z_INDEX,
      header: {
        data: {
          title: this._wordings._library.chat.citationSource({
            bindings: { marker: citation.marker },
          }),
        },
      },
      body: {
        component: CitationDetailComponent,
        bindings: {
          inputs: { citation },
        },
      },
      context: {
        closeClick: () => {
          this._modalService.close(uid);
        },
      },
    }));
  }
}
